// extracted by mini-css-extract-plugin
export default {"container":"add-update-user_container__QV31M","txt01":"add-update-user_txt01__oZnbQ"};